export var getCheckboxColors = function(props, theme) {
    var colors;
    if (props.disabled) {
        colors = theme.checkboxes.disabled;
    } else if (props.secondary) {
        colors = theme.checkboxes.secondary;
    } else {
        colors = theme.checkboxes.primary;
    }
    var _props_color;
    var fill = (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : colors.fill;
    var isActive = props.checked || props.intermediate;
    var _props_color1, _props_borderColor;
    return {
        fill: fill,
        icon: (_props_color1 = props.color) !== null && _props_color1 !== void 0 ? _props_color1 : colors.icon,
        border: (_props_borderColor = props.borderColor) !== null && _props_borderColor !== void 0 ? _props_borderColor : isActive ? colors.borderActive : colors.border,
        borderActive: colors.borderActive,
        base: colors.base,
        checked: colors.checked,
        hover: colors.hover
    };
};
